export const EXSBINVOICESTATUS_SHOW_RESET = 'EXSBINVOICESTATUS_SHOW_RESET'
export const EXSBINVOICESTATUS_SHOW_SET_ERROR = 'EXSBINVOICESTATUS_SHOW_SET_ERROR'
export const EXSBINVOICESTATUS_SHOW_SET_RETRIEVED = 'EXSBINVOICESTATUS_SHOW_SET_RETRIEVED'
export const EXSBINVOICESTATUS_SHOW_TOGGLE_LOADING = 'EXSBINVOICESTATUS_SHOW_TOGGLE_LOADING'
